import { render, staticRenderFns } from "./UniqueForm.vue?vue&type=template&id=05a0ee5a"
import script from "./UniqueForm.vue?vue&type=script&lang=js"
export * from "./UniqueForm.vue?vue&type=script&lang=js"
import style0 from "./UniqueForm.vue?vue&type=style&index=0&id=05a0ee5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports